const factoryKeys = {
  participants: (spaceId) => ['participants', spaceId],
  deletedSectionsBySpaceId: (spaceId) => ['deletedSections', spaceId],
};

export default factoryKeys;
